import { render, staticRenderFns } from "./showRespuestas.vue?vue&type=template&id=00f125cc"
import script from "./showRespuestas.vue?vue&type=script&lang=js"
export * from "./showRespuestas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports